import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/egenkontrollparm";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/binder")(
  enRouteOptions(routeOptions, {
    svPath: "/egenkontrollparm",
    title: 'Self-Monitoring Binder for Alcohol Service 2026',
    description: 'A ready-made Swedish self-monitoring programme (egenkontrollprogram) for restaurants and bars: PDF and Word, SEK 790 or SEK 395 for premium members.',
    ogImage: "https://alkoholprovet.se/og/default.jpg",
    noindex: false,
  }),
);
